module.exports = __webpack_public_path__ + "images/e2ca552a25441572b1aff51c333c36e9.png";